<template>
	<div>
		<el-card class="box-card">
			<template #header>
				<el-button @click="addUser" type="primary">
					{{ $t('device.add') }}
				</el-button>
			</template>
			<el-table :data="appData" :default-sort="{prop: 'date', order: 'descending'}" border stripe
				style="width: 100%">
				<el-table-column label="ID" prop="id" width="60"></el-table-column>
				<el-table-column label="组织" prop="client_name" width="180"></el-table-column>
				<el-table-column label="MAC" prop="mac" width="250"></el-table-column>
				<el-table-column label="名称" prop="name" width="250"></el-table-column>
				<el-table-column label="类型" prop="type" width="150">
					<template #default="scope">{{ getTypeName(scope.row.type)  }}</template>
				</el-table-column>
				<el-table-column label="时间" prop="update_at" width="180"></el-table-column>
				<el-table-column :label="$t('device.operating')" width="150">
					<template #default="scope">
						<el-button @click="handleEdit(scope.row)" type="primary" size="small">编辑</el-button>
						<el-button @click="handleDelete(scope.row)" type="primary" size="small">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination :page-size="formInline.size" :page-sizes="[10, 20, 50, 200]" :total="listCount"
				@current-change="handleCurrentChange" @size-change="handleSizeChange" fixed="right"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>

			<el-dialog center title="添加/编辑" top="30vh" v-model="addPop" width="50%">
				<el-form :model="addForm" ref="addForm" :rules="rules">
					<div style="display: flex; gap: 20px;">
						<el-form-item label="组织" label-width="120px" prop="client_id">
							<el-cascader :options="clientOpts" placeholder="组织"
								v-model="addForm.client_id"></el-cascader>
						</el-form-item>
					</div>
					
					<el-form-item label="MAC" label-width="120px" prop="mac">
						<el-input type="text" v-model="addForm.mac" placeholder="参考格式:209BA5CC03EF"></el-input>
					</el-form-item>
					<el-form-item label="名称" label-width="120px" prop="name">
						<el-input type="text" v-model="addForm.name" placeholder=""></el-input>
					</el-form-item>
					<el-form-item label="类型" label-width="120px" prop="type">
						<el-select v-model="addForm.type" placeholder="请选择类型" style="width:100%">
							<el-option v-for="item in typeOptions" :key="item.value" :label="item.label"
								:value="item.value"></el-option>
						</el-select>
					</el-form-item>
				</el-form>
				<template #footer>
					<span class="dialog-footer">
						<el-button @click="addPop = false">{{ $t('device.cancel') }}</el-button>
						<el-button @click="handleSubmit" type="primary">{{ $t('device.confirm') }}</el-button>
					</span>
				</template>
			</el-dialog>
		</el-card>
	</div>
</template>
<script>
	import message from "../../model/beacon";
	import client from "../../model/client";
	export default {
		name: "user",
		data() {
			return {
				dialogFormVisible: false,
				formInline: {
					mac: "",
					name: "",
					page: 1,
					size: 50
				},
				resetform: {
					mac: "",
					name: "",
				},
				listCount: 0,
				appData: [],
				addPop: false,
				addForm: {
					client_id:"",
					mac: "",
					name: "",
					type:1,
				},
				clientListOpts: [],
				clientOpts: [],
				roleOpts: [],
				typeOptions: [{
						value: 1,
						label: "兴趣类"
					},
					{
						value: 2,
						label: "安全类"
					},
					{
						value: 3,
						label: "其他"
					}
				],
				rules: {
					mac: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}],
					name: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}],
					type: [{
						required: true,
						message: '不能为空',
						trigger: "blur"
					}]
				}
			};
		},
		async mounted() {
			await this.loadData();
			this.loadClient();
		},
		methods: {
			truncateText(text, limit) {
				return text?.length > limit ? `${text.substr(0,  limit)}...` : text || '-';
			},
			getTypeName(type) {
				const target = this.typeOptions.find(item => item.value === type);
				return target?.label || '未知';
			},
			resetFun() {
				this.formInline.mac = ''
				this.formInline.name = ''
				this.loadData()
			},
			async loadData() {
				const ret = await message.list(this.formInline)
				if (ret.code === 200) {
					this.appData = ret.data.list;
					this.listCount = ret.data.count;
				}
			},
			async handleSubmit() {
				this.$refs.addForm.validate(async valid => {
					if (valid) {
						const params = JSON.parse(JSON.stringify(this.addForm))
						const ret = await message.save(params)
						if (ret.code === 200) {
							this.addPop = false
							this.$message.success(ret.message)
							this.loadData()
						} else {
							this.$message.warning(ret.message)
						}
					} else {
						return false;
					}
				});
			},
			seachFun() {
				this.loadData();
			},
			addUser() {
				this.addPop = true;
				setTimeout(() => {
					this.$refs.addForm.resetFields()
					this.addForm = {
						status: "",
						comment: "",
					}
				})
			},
			handleEdit(row) {
				this.addPop = true;
				setTimeout(() => {
					this.$refs.addForm.resetFields()
					let rowData = JSON.parse(JSON.stringify(row))
					this.addForm.client_id = rowData.client_id
					this.addForm.mac = rowData.mac
					this.addForm.name = rowData.name
					this.addForm.id = rowData.id
					this.addForm.type = rowData.type
				})
			},
			async handleDelete(row) {
				this.$confirm(this.$t('device.delete_note'), this.$t('device.tip'), {
						confirmButtonText: this.$t('device.confirm'),
						cancelButtonText: this.$t('device.cancel'),
						type: "warning"
					})
					.then(async () => {
						const ret = await message.delete({
							id: row.id
						});
						if (ret.code === 200) {
							this.$message.success('操作成功');
							await this.loadData()
						} else {
							this.$message.error(ret.message);
						}
					})
					.catch(error => {
						console.error(' 操作失败:', error);
						this.$message.error(' 操作失败，请稍后再试');
					});
			},
			handleSizeChange(val) {
				this.formInline.size = val;
				this.loadData();
			},
			handleCurrentChange(val) {
				this.formInline.page = val;
				this.loadData();
			},
			async loadClient() {
				const ret = await client.list({});
				if (ret.code === 200) {
					ret.data.forEach(i => {
						let options = {
							value: i.id,
							label: i.name,
							children: []
						};
						this.clientListOpts.push({ //list
							value: i.id,
							label: i.name
						});
			
						if (i.children.length > 0) {
							this.clientOpts.push({
								value: i.id,
								label: i.name
							});
							i.children.forEach(v => {
								let opts = {
									value: v.id,
									label: v.name
								};
								this.clientListOpts.push({ //list
									value: v.id,
									label: v.name
								});
			
								if (v.children.length > 0) {
									options.children.push({
										value: v.id,
										label: v.name
									});
									opts.children = [];
									v.children.forEach(item => {
										let children = {
											value: item.id,
											label: item.name,
										};
										this.clientListOpts.push({ //list
											value: item.id,
											label: item.name
										});
			
										if (item.children.length > 0) {
											children.children = [];
											item.children.forEach(val => {
												children.children.push({
													value: val.id,
													label: val.name
												});
												this.clientListOpts.push({ //list
													value: val.id,
													label: val.name
												});
											})
										}
										opts.children.push(children);
									});
								}
								options.children.push(opts);
							});
						}
						this.clientOpts.push(options);
					});
				}
				console.log(JSON.stringify(this.clientOpts));
			}
		}
	};
</script>
<style scoped>
	.demo-form-inline {
		margin-top: 20px;
	}

	.card-header {
		display: flex;
		align-items: center;
	}

	.el-pagination {
		margin: 30px 0px;
		float: right;
	}

	.tag-item {
		background-color: #f0f0f0;
		padding: 5px 10px;
		margin-right: 10px;
		border-radius: 4px;
		display: inline-flex;
		align-items: center;
	}

	.tag-item .el-icon-close {
		margin-left: 8px;
		cursor: pointer;
		color: red;
	}

	.tag-item .el-icon-close:hover {
		color: #666;
	}
</style>